// API配置
const API_CONFIG = {
  // 后端API基础URL
  // 默认使用 Laravel 标准端口 8000；BASE_URL 为域名根，接口路径统一带 /api 前缀
  // 可以通过环境变量 REACT_APP_API_BASE_URL 覆盖（值不带 /api，如 https://agent.xihangedu.com）
  BASE_URL: (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000').replace(/\/api\/?$/, ''),
  
  // 验证码API
  CAPTCHA: {
    GENERATE: '/api/captcha/generate',
    VERIFY: '/api/captcha/verify'
  },
  
  // 其他API端点
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    MODIFY: '/api/auth/modify',
    // 微信登录相关
    WECHAT: {
      QR_CODE: '/api/auth/wechat/qr-code',
      QR_STATUS: '/api/auth/wechat/qr-status',
      CALLBACK: '/api/auth/wechat/callback'
    },
    // 短信验证码登录
    SMS: {
      SEND: '/api/auth/send-sms',
      LOGIN: '/api/auth/sms-login'
    }
  },
  
  UNIVERSITIES: {
    LIST: '/api/schools',
    DETAIL: '/api/universities',
    FACULTIES: '/api/universities',
    PROGRAMS: '/api/universities',
    MEDIA: '/api/universities',
    CONTENT: '/api/universities',
    NEWS: '/api/universities',
    STATS: '/api/universities'
  },
  
  PROGRAMS: {
    SEARCH: '/api/programs/search',
    DETAIL: '/api/programs'
  },
  
  // 申请查询API
  APPLICATION_QUERY: {
    SEARCH: '/api/application/query',
    DETAIL: '/api/application/detail',
    USER_STUDENT: '/api/application/user-student', // 根据用户ID查询关联的学生信息
    BIND_STUDENT: '/api/application/bind-student',  // 绑定学生到当前用户
    UNBIND_STUDENT: '/api/application/unbind-student'  // 解绑学生信息
  }
};

export default API_CONFIG;
